<template>
    <fragment>
        <StudentPosterIndex/>
        <StudentPosterAdmin/>
        <StudentPosterSettings/>
        <StudentPosterWooCommerce/>
        <TxProductStats/>
    </fragment>
</template>

<script>
    import StudentPosterWooCommerce from "./__partials__/StudentPosterWooCommerce";
    import StudentPosterSettings from "./__partials__/StudentPosterSettings";
    import StudentPosterIndex from "./__partials__/StudentPosterIndex";
    import StudentPosterAdmin from "./__partials__/StudentPosterAdmin";

    let layout = lovemap.vue_env;

    export default {
        name: "index",
        layout: layout,
        components: {
            StudentPosterAdmin,
            StudentPosterIndex,
            StudentPosterSettings,
            StudentPosterWooCommerce
        }
    }
</script>

<style scoped>

</style>
